import React from "react";
import Navbar from "../../components/Header";
import Footer from "../../components/Footer";

function Terms() {
    return (
        <div>
            <Navbar diffHeader={true} />
            <section className="py-24 px-4 sm:px-6 lg:px-8 bg-white border-t border-gray-200 text-left" >
                <div className="max-w-4xl mx-auto">
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8 text-center">
                        Terms and Conditions
                    </h2>
                    <p className="mb-6 text-gray-700 leading-relaxed">
                        Welcome to <a href="https://www.ucsprimerealestate.com" className="text-blue-700 hover:underline">www.ucsprimerealestate.com</a> (the “Website”), operated by UCS
                        Prime Real Estate. By accessing or using this Website, you agree to be bound by
                        the following Terms and Conditions. If you do not agree, please do not use this
                        Website.
                    </p>

                    <h3 className="text-2xl font-semibold text-gray-900 mb-4 mt-8">1. Company Information</h3>
                    <p className="mb-4 text-gray-700">This Website is owned and managed by:</p>
                    <ul className="list-disc list-inside text-gray-700 mb-6 space-y-1">
                        <li>UCS Prime Real Estate</li>
                        <li>Registered in the Emirate of Dubai, UAE</li>
                        <li>Licensed by the Dubai Economic Department (DED) and Real Estate Regulatory Agency (RERA)</li>
                    </ul>

                    <h3 className="text-2xl font-semibold text-gray-900 mb-4 mt-8">2. Use of Website</h3>
                    <p className="mb-4 text-gray-700">You agree to use this Website solely for:</p>
                    <ul className="list-disc list-inside text-gray-700 mb-6 space-y-1">
                        <li>Browse real estate listings and services offered by UCS Prime Real Estate.</li>
                        <li>Inquiring about properties or submitting contact forms.</li>
                        <li>Applying for a job or partnership opportunity.</li>
                    </ul>
                    <p className="font-semibold text-gray-900 mb-2">Prohibited Activities:</p>
                    <ul className="list-disc list-inside text-gray-700 mb-6 space-y-1">
                        <li>Use of the Website for fraudulent or unlawful purposes.</li>
                        <li>Copying, scraping, or reproducing content without permission.</li>
                        <li>Interfering with Website functionality or security.</li>
                    </ul>

                    <h3 className="text-2xl font-semibold text-gray-900 mb-4 mt-8">3. Property Listings Disclaimer</h3>
                    <p className="mb-4 text-gray-700">UCS Prime Real Estate makes every effort to provide accurate and up-to-date information. However:</p>
                    <ul className="list-disc list-inside text-gray-700 mb-6 space-y-1">
                        <li>All property listings, prices, and availability are subject to change without prior notice.</li>
                        <li>Visuals, brochures, and floor plans are for illustration purposes only and may not represent the final product.</li>
                        <li>We do not guarantee the accuracy, completeness, or timeliness of any third-party content.</li>
                    </ul>

                    <h3 className="text-2xl font-semibold text-gray-900 mb-4 mt-8">4. Intellectual Property</h3>
                    <p className="mb-6 text-gray-700">
                        All content on the Website — including text, logos, images,
                        videos, property data, and branding — is the property of UCS Prime Real Estate
                        or its partners. You may not reproduce, distribute, or modify any part of the
                        Website without prior written permission.
                    </p>

                    <h3 className="text-2xl font-semibold text-gray-900 mb-4 mt-8">5. Limitation of Liability</h3>
                    <p className="mb-6 text-gray-700">
                        UCS Prime Real Estate shall not be liable for any direct,
                        indirect, incidental, or consequential damages resulting from:
                    </p>
                    <ul className="list-disc list-inside text-gray-700 mb-6 space-y-1">
                        <li>Use or inability to use the Website.</li>
                        <li>Reliance on information provided on the Website.</li>
                        <li>Delays or disruptions due to technical issues or server errors.</li>
                    </ul>

                    <h3 className="text-2xl font-semibold text-gray-900 mb-4 mt-8">6. Third-Party Links</h3>
                    <p className="mb-6 text-gray-700">
                        The Website may include links to third-party websites
                        (e.g., developer websites, portals). We are not responsible for the content,
                        policies, or accuracy of any third-party websites and disclaim all liability
                        for their use.
                    </p>

                    <h3 className="text-2xl font-semibold text-gray-900 mb-4 mt-8">7. Privacy and Data Usage</h3>
                    <p className="mb-6 text-gray-700">
                        Your use of this Website is also governed by our Privacy Policy.
                        By using the Website, you consent to the collection, use, and disclosure of
                        your information in accordance with UAE data protection regulations.
                    </p>

                    <h3 className="text-2xl font-semibold text-gray-900 mb-4 mt-8">8. Governing Law</h3>
                    <p className="mb-6 text-gray-700">
                        These Terms and Conditions are governed by the laws of the United Arab Emirates and the Emirate of Dubai. Any disputes
                        shall be subject to the exclusive jurisdiction of the Dubai Courts.
                    </p>

                    <h3 className="text-2xl font-semibold text-gray-900 mb-4 mt-8">9. Modifications to Terms</h3>
                    <p className="mb-6 text-gray-700">
                        We reserve the right to amend these Terms and Conditions at
                        any time. Continued use of the Website after updates constitutes your
                        acceptance of the revised terms.
                    </p>

                    <h3 className="text-2xl font-semibold text-gray-900 mb-4 mt-8">10. Contact Us</h3>
                    <p className="mb-6 text-gray-700">
                        If you have any questions about these Terms, please
                        contact:
                    </p>
                    <p className="text-lg font-medium text-gray-700">
                        <span role="img" aria-label="email emoji">📧</span> Email: <a href="mailto:propertyhub@ucs-mail.com" className="text-blue-700 hover:underline">propertyhub@ucs-mail.com</a>
                    </p>
                </div>
            </section>
            <Footer />
        </div>
    )
}

export default Terms;